import { gql } from "@apollo/client";

export const BUSINESS_TYPE_FRAGMENT = gql`
  fragment BusinessTypeFields on BusinessTypeType {
    id
    name
    description
  }
`;

export const INDUSTRY_TYPE_FRAGMENT = gql`
  fragment IndustryTypeFields on IndustryType {
    id
    name
    description
  }
`;

export const BUSINESS_PROFILE_FRAGMENT = gql`
  fragment BusinessProfileFields on BusinessProfileType {
    id
    createdAt
    updatedAt
    businessNumber
    businessName
    businessType {
      ...BusinessTypeFields
    }
    otherBusinessType {
      ...BusinessTypeFields
    }
    industry {
      ...IndustryTypeFields
    }
    otherIndustryType {
      ...IndustryTypeFields
    }
    gstNumber
    zipcode
    city
    state
    address1
    address2
    email
    stateCode
    salesTarget
    subscriptionExpiry
    alternatePhone
    isActive
    upi
    bank
    accountHolder
    accountNumber
    ifsc
    licenseNumber
    hasActiveSubscription
    profileImage
  }
  ${BUSINESS_TYPE_FRAGMENT}
  ${INDUSTRY_TYPE_FRAGMENT}
`;
